import React, {Component} from 'react';
import {connect} from 'react-redux';
import AnsweredQuestion from '../ApplicationPolicy/answeredQuestion';
import {updateFormQuestionAnswerAfterSubmit} from "../../actions/newApplication";
import moment from 'moment';
import _ from 'lodash';
import {
    ANSWER_UPDATE_ACTION,
    ANSWER_UPDATE_TYPE,
    APPLICATION_FORM_FIELDS,
    APPLICATION_OPPONENT_ENUM,
    WORK_SOURCE_EDIT_WARNING
} from "../../helpers/variables";
import {checkIfQuestionAnswerUpdateRequiresARAGApproval} from "../../helpers/approvalSettings/functions";
import {getValidDate, readFileAsBase64Async} from "../../helpers/functions";
import AttachmentsList from "../General/attachmentsList";
import {
    arrayUnique,
    checkQuestionsMayBetriggered,
    checkWhichQuestionTriggeredConditional,
    getTriggeredQuestionFromQuestionsMayBeTriggered
} from "../../helpers/questions/functions";
import { Button, Loader, Alert } from 'arag-ui-lib';
import { INPUT_TYPE } from '../../helpers/formGroupVariants';
import {
    PRIMARY,
    QUATERNARY,
    RIGHT,
    APPLICATION_MEDICAL_EXPERT_FEES,
    DOTS,
    SUBMIT,
    APPLICATION_OPPONENT,
    INFO,
    ERROR,
    ATTENDANCE_ESTIMATED_COST,
    BREACH_CAUSATION_CP_ID,
    NAME,
    NATURE_OF_EXPERT,
    PARTIAL_ESTIMATED_COST,
    WHY_SPECIFIC_EXPERT,
    SOLICITOR_REFERENCE_MN,
    DATE_OF_BIRTH_MN,
    POST_CODE_MN,
    ADDRESS_MN,
    WORK_SOURCE_ID_MN,
    MOMENT_DATE_FORMAT,
    CLIENT_NAME_MN,
    APPLICATION,
    OPPONENT_NAME_MN,
    MEDIUM,
    INSURED_OPTION_ID,
} from "../../helpers/constants";
import CONTENT_STRINGS from '../../helpers/contentStrings';


class FormQuestionAnswerEditForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            question: {...this.props.question},
            questionAnswer: this.props.questionAnswer,
            opponent: {...this.props.opponent},
            medicalExpertFees: this.props.medicalExpertFees?[...this.props.medicalExpertFees]:[],
            breachCausationCp: {...this.props.breachCausationCp},
            formData: {...this.props.Store.formData},
            questionWithChildQuestionIds: this._getInitialAnswers(this.props.question),
            errorMessage: null,
            attachments: [],
            triggeredQuestion: [...this.props.triggeredQuestions],
        };
    }

  componentDidUpdate(prevProps, prevState) {
      let questionsMayBeTriggered = checkQuestionsMayBetriggered(prevState.formData, this.state.formData, this.props.Store.triggeredQuestions)
      if(questionsMayBeTriggered.length > 0){
          const triggered = getTriggeredQuestionFromQuestionsMayBeTriggered( this.state.formData, this.props.Store.questions.filter(x=>questionsMayBeTriggered.includes(x.id)),this.props.Store.questions);
          if(triggered.length > 0){
              this.setState({triggeredQuestion: triggered})
          } else {
            //   this.clearTriggeredQuestion();
              this.setState({triggeredQuestion: []})
              this.props.ChangeNewAppField('triggeredQuestionsToDisplay', []);

          }
      }
  }

    onDrop = async (files, questionId) => {
        if(files){
            const attachments = [];
            await Promise.all(files.map(async file => {
                const base64String = await readFileAsBase64Async(file);
                attachments.push({
                    name: file.name,
                    encodedFile: base64String,
                    fileType: file.type,
                    questionId: questionId
                });
            }));
            this.setState({attachments: [...this.state.attachments, ...attachments]});
        }

    };

    clearTriggeredQuestion = () => {
        let newFormData =  {
            ...this.state.formData
        };
        if(this.state.triggeredQuestion){
            newFormData[this.state.triggeredQuestion.id] = ''
        }
        this.setState({
            ...this.state,
            triggeredQuestion: null,
            formData: newFormData
        })
    };

    removeAttachment = (attachment, attachmentIndex) => {
        this.setState({
            attachments: this.state.attachments.filter((item, index) => index !== attachmentIndex)
        })
    };

    _getInitialAnswers = () => {
        if(this.props.question.isStandard) return {};
        if(this.props.question.machineName === OPPONENT_NAME_MN) return {};
        const allQuestionIds = [this.props.question.id, ...this._getChildQuestionsIds( this.props.question ) ];
        let questionWithChildQuestionIds = {};
        _.forEach(allQuestionIds, questionId => {
            const q = _.find(this.props.Store.questions, qu => {return qu.id === questionId});
            if(q) {
                questionWithChildQuestionIds = {
                    ...questionWithChildQuestionIds,
                    [questionId]: this._getChildQuestionsIds( q )
                }
            }
        });
        return questionWithChildQuestionIds;
    };

    _getChildQuestionsIds = ( question ) => {
        let ids = [];
        _.forEach(question.options, option => {
            _.forEach(option.childQuestions, childQuestion => {
                ids.push(childQuestion.id);
                ids =  [...ids, ...this._getChildQuestionsIds(childQuestion)]
            })
        });
        //add childs of conditional questions
        if( this.props.triggeredQuestions.length >0)
        {
            let triggeredByIds = [];
            this.props.Store.questionsTriggeredByQuestions.map(triggeredQuestion => {
                if (triggeredQuestion.questionDisplaySettings.length > 0) {
                    triggeredQuestion.questionDisplaySettings.forEach(condition => {
                        condition.conditions.forEach(ds => {
                            ds.triggeredByQuestionIds.forEach(id => {
                                triggeredByIds = [...triggeredByIds, id]
                            })
                        })
                    });
                }
                if (triggeredByIds.includes(question.id)) {
                    // display = true;
                    ids.push(triggeredQuestion.id);
                }
            });
        }
        return arrayUnique(ids);
    };

    _handleTextInputChange = (key, value) => {
        this.setState( state => ({
            ...state,
            questionAnswer: this.state.question.isStandard?value:this.state.questionAnswer,
            formData: this.state.question.isStandard?
                this.state.formData
                :
                {
                    ...this.state.formData,
                    [key]: value
                }
        }))
    };

    _handleSelectInputChange = (key, value) => {
        const val = value;
        const name = key;
        let formData = {};
        let questionIdsWithAttachmentsToFilter = [];
        if(!this.state.question.isStandard){
            formData = _.mapValues(this.state.formData, (data, key) => {
                let x = this.state.questionWithChildQuestionIds[name];
                if(x.includes(parseInt(key))){
                    questionIdsWithAttachmentsToFilter.push(key.toString());
                    return ''
                }
                return data
            })
        }
        this.setState( state => ({
            ...state,
            questionAnswer: this.state.question.isStandard?val:this.state.questionAnswer,
            formData: this.state.question.isStandard?
                this.state.formData
                :
                {
                    ...formData,
                    [name]: val
                },
            attachments: this.state.attachments.filter(a =>
                a.questionId
                && !questionIdsWithAttachmentsToFilter.includes(a.questionId.toString())
            )
        }))
    };

    _handleDateInputChange = (key, value) => {
        this.setState( state => ({
            ...state,
            questionAnswer: this.state.question.isStandard?value:this.state.questionAnswer,
            formData: this.state.question.isStandard?
                this.state.formData
                :
                {
                    ...this.state.formData,
                    [key]: value
                }
        }))
    };

    //Handle Opponent questions.
    _handleChangeOpponent = (fieldName, value) => {
        const satisfiedOptionIdValue  = (
            (fieldName === INSURED_OPTION_ID) && 
            (this.state.opponent.insuredOptionId !== value)
        )
            ? ''
            : this.state.opponent.satisfiedOptionId;

        if (!fieldName) return;
        const updatedOpponent = {
            ...this.state.opponent,
            satisfiedOptionId: satisfiedOptionIdValue,
            [fieldName]: value,
        }
        this.setState({
            ...this.state,
            opponent: updatedOpponent,
        });
 
    };

    _updateMedicalExpertFees = (newDataObject) => {
        const { key, name, value } = newDataObject;
        const updated = this.state.medicalExpertFees.map((fee) => {
            if (fee.id === key) {
                return {
                    ...fee,
                    [name]: value
                };
            }
            return fee;
        });
        this.setState({ medicalExpertFees: updated });
    };

    _addMedicalExpertFee = () => {
        this.setState( state => ({
            ...state,
            medicalExpertFees: [
                ...this.state.medicalExpertFees,
                {
                    name: '',
                    natureOfExpert: '',
                    whySpecificExpert: '',
                    breachCausationCpId: '',
                    partialEstimatedCost: '',
                    attendanceEstimatedCost: ''
                }
            ]
        }));
    };

    _removeMedicalExpertFee = (key) => {
        let medicalExpertFees = [...this.state.medicalExpertFees];
        medicalExpertFees.splice(key,1);
        this.setState( state => ({
            ...state,
            medicalExpertFees: medicalExpertFees
        }));

    };

    validateMedicalExpertFeeForSubmit = (fee) => {
        if(
            !fee.attendanceEstimatedCost
            || !fee.breachCausationCpId
            || !fee.name
            || !fee.natureOfExpert
            || !fee.partialEstimatedCost
            || !fee.whySpecificExpert
        ) {
            return false
        }

        return true;
    };

    onSave = (evt) => {
        evt.preventDefault();
        if(!this.props.editingSetting){
            return;
        }
        this.setState({errorMessage: null});
        const updateAction = (this.props.applicationUpdateAction && this.props.applicationUpdateAction === ANSWER_UPDATE_ACTION.ADD) ?
            ANSWER_UPDATE_ACTION.ADD : ANSWER_UPDATE_ACTION.UPDATE;

        let sendBody = {
            applicationId: this.props.Store.selectedApplication.id,
            applicationAnswerApprovalSettingId: this.props.editingSetting.id
        };

        if(this.props.editingSetting.tableName === APPLICATION) {
            let item = {};

            if(this.state.question.machineName === CLIENT_NAME_MN) {
                item = {columnName: APPLICATION_FORM_FIELDS.CLIENT_NAME.fieldName, text: this.state.questionAnswer};
            } else if(this.state.question.machineName === SOLICITOR_REFERENCE_MN ) {
                item = {columnName: APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fieldName, text: this.state.questionAnswer};
            } else if(this.state.question.machineName === ADDRESS_MN ) {
                item = {columnName: APPLICATION_FORM_FIELDS.ADDRESS.fieldName, text: this.state.questionAnswer};
            } else if(this.state.question.machineName === POST_CODE_MN ) {
                item = {columnName: APPLICATION_FORM_FIELDS.POST_CODE.fieldName, text: this.state.questionAnswer};
            } else if(this.state.question.machineName === WORK_SOURCE_ID_MN ) {
                item = {columnName: APPLICATION_FORM_FIELDS.WORK_SOURCE.fieldName, referencedEntityId: this.state.questionAnswer};
            } else if(this.state.question.machineName === DATE_OF_BIRTH_MN ) {
                item = {columnName: APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fieldName, date: moment.utc(this.state.questionAnswer, MOMENT_DATE_FORMAT).toISOString()};
            }

            sendBody = {
                ...sendBody,
                entityId: this.props.Store.selectedApplication.id,
                applicationUpdateType: ANSWER_UPDATE_TYPE.APPLICATION,
                applicationUpdateAction: ANSWER_UPDATE_ACTION.UPDATE,
                items: [item]
            }
        }
        else if (this.props.editingSetting.tableName === APPLICATION_OPPONENT){
            const items = [];
            items.push({columnName: APPLICATION_OPPONENT_ENUM.OpponentName, text: this.state.opponent.name ? this.state.opponent.name : null});
            this.state.opponent.prospectsOptionId && items.push({columnName: APPLICATION_OPPONENT_ENUM.ProspectsAgainstOpponent, referencedEntityId: this.state.opponent.prospectsOptionId ? this.state.opponent.prospectsOptionId : null});
            this.state.opponent.insuredOptionId && items.push({columnName: APPLICATION_OPPONENT_ENUM.IsOpponentInsured, referencedEntityId: this.state.opponent.insuredOptionId ? this.state.opponent.insuredOptionId : null});
            this.state.opponent.satisfiedOptionId &&  items.push({columnName: APPLICATION_OPPONENT_ENUM.OpponentNotInsuredSatisfiedHasFunds, referencedEntityId: this.state.opponent.satisfiedOptionId ? this.state.opponent.satisfiedOptionId : null});
            this.state.opponent.insurerOptionId && items.push({columnName: APPLICATION_OPPONENT_ENUM.WhoIsTheInsurer, referencedEntityId: this.state.opponent.insurerOptionId ? this.state.opponent.insurerOptionId : null});
            this.state.opponent.otherInsurerName && items.push({columnName: APPLICATION_OPPONENT_ENUM.NameOfInsurerOther, text: this.state.opponent.otherInsurerName ? this.state.opponent.otherInsurerName : null});
            sendBody = {
                ...sendBody,
                entityId: this.state.opponent.id,
                applicationUpdateType: ANSWER_UPDATE_TYPE.APP_OPPONENT,
                applicationUpdateAction: updateAction,
                items: items
            }
        }
        else if (this.props.editingSetting.questionId) {
            const items = [];
            const questionTree = [this.state.question.id, ...this._getChildQuestionsIds(this.state.question)];
            const questionIds = arrayUnique(questionTree);
            const conditionalQuestionsTree = this.props.Store.questionsTriggeredByQuestions.map(conditionalQuestion => {
                 return this._getChildQuestionsIds(conditionalQuestion)
            });
            var conditionalQuestionsChildIds=[]
            conditionalQuestionsTree.forEach(ccq => {ccq.forEach(id => conditionalQuestionsChildIds.push(id))} )

            const activeConditionalQuestionsTree = this.state.triggeredQuestion.map(activeConditionalQuestion => {
                return this._getChildQuestionsIds(activeConditionalQuestion)
           });
           var activeConditionalQuestionsChildIds=[]
           activeConditionalQuestionsTree.forEach(ccq => {ccq.forEach(id => activeConditionalQuestionsChildIds.push(id))} )
            // construct the pending answer items
            
            questionIds.forEach(questionId => {
                var istriggered = true;
                const question = this.props.Store.questions.find(q =>  q.id.toString() === questionId.toString() );
                const answer = this.state.formData[questionId];
                if(this.props.Store.questionsTriggeredByQuestions.some(q => q.id ==question.id) )
                {
                    var triggerQuestionsGroupIds =  checkWhichQuestionTriggeredConditional(this.state.formData,this.props.Store.questions,question);
                      istriggered = triggerQuestionsGroupIds.some(c => c == this.state.question.groupId );
                }
                if(question.inputType === INPUT_TYPE.UPLOAD){
                }
                if(
                    question
                    && answer
                    && istriggered
                ){
                    items.push({
                        questionId: question.id,
                        optionId: question.inputType === INPUT_TYPE.DROP_DOWN? answer: null,
                        text: ((question.inputType === INPUT_TYPE.TEXT) || (question.inputType === INPUT_TYPE.TEXT_AREA))?answer:null,
                        date: question.inputType === INPUT_TYPE.CALENDAR ? (getValidDate(answer).toDateString() ?? null):null,
                        amount: question.inputType === INPUT_TYPE.AMOUNT ? answer : null
                    })
                }
            });
            // construct the pending attachments
            const pendingAttachments = [];
            this.state.attachments.forEach(attachment => {
                //map attachment to question
                let foundQuestion = null;
                if(attachment.questionId){
                    foundQuestion = this.props.Store.questions
                        .find(q =>  q.id.toString() === attachment.questionId.toString() );
                }
                pendingAttachments.push({
                    name: attachment.name,
                    encodedFile: attachment.encodedFile,
                    fileType: attachment.fileType,
                    questionId: foundQuestion ? foundQuestion.id : null
                });

            });


            sendBody = {
                ...sendBody,
                entityId: this.state.question.id,
                applicationUpdateType: ANSWER_UPDATE_TYPE.QUESTION,
                applicationUpdateAction: ANSWER_UPDATE_ACTION.UPDATE,
                items: items,
                attachments: pendingAttachments
            }
        }
        
        else if (
            this.props.editingSetting.tableName === APPLICATION_MEDICAL_EXPERT_FEES
            && this.state.medicalExpertFees.length === 1
        ){
            const items = [];
            const medicalExpertFee = this.state.medicalExpertFees[0];
            const isValid = this.validateMedicalExpertFeeForSubmit(medicalExpertFee);
            if(!isValid){
                this.setState({errorMessage: CONTENT_STRINGS.MEDICAL_EXPERT_FEES_TABLE_WARNING});
                return;
            }

            items.push({columnName: ATTENDANCE_ESTIMATED_COST, amount: medicalExpertFee.attendanceEstimatedCost});
            items.push({columnName: BREACH_CAUSATION_CP_ID, referencedEntityId: medicalExpertFee.breachCausationCpId});
            items.push({columnName: NAME, text: medicalExpertFee.name});
            items.push({columnName: NATURE_OF_EXPERT, text: medicalExpertFee.natureOfExpert});
            items.push({columnName: PARTIAL_ESTIMATED_COST, amount: medicalExpertFee.partialEstimatedCost});
            items.push({columnName: WHY_SPECIFIC_EXPERT, text: medicalExpertFee.whySpecificExpert});
            sendBody = {
                ...sendBody,
                entityId: this.state.medicalExpertFees[0].id,
                applicationUpdateType: ANSWER_UPDATE_TYPE.APP_MED_EXP_FEES,
                applicationUpdateAction: updateAction,
                items: items
            }
        }

        this.props.updateFormQuestionAnswerAfterSubmit({
            sendBody
        })
    };

    render() {
        const requiresARAGApproval = checkIfQuestionAnswerUpdateRequiresARAGApproval(
            this.props.editingSetting,
            this.props.approvalOptions,
            this.props.userRoles
        );
        const btnLabel = requiresARAGApproval ? CONTENT_STRINGS.REQUEST_APPROVAL : CONTENT_STRINGS.SAVE;
        return (
            <div>
                <form className={'form-horizontal'} onSubmit={this.onSave}>
                    {this.state.question.machineName === WORK_SOURCE_ID_MN
                    ?
                        <Alert 
                            variant={INFO}
                            label={WORK_SOURCE_EDIT_WARNING}
                        />
                    :
                        null
                    }
                    <div key={this.state.question.id}>
                        <AnsweredQuestion
                            multipleFilesAllowed={true}
                            application={this.props.Store.selectedApplication}
                            formData={this.state.formData}
                            opponent={this.state.opponent}
                            question={this.state.question}
                            questionAnswer={this.state.question.isStandard
                                ? this.state.questionAnswer
                                : this.state.formData[this.state.question.id]
                            }
                            medicalExpertFees={this.state.medicalExpertFees}
                            breachCausationCp={this.state.breachCausationCp}
                            _removeMedicalExpertFee={this._removeMedicalExpertFee}
                            _addMedicalExpertFee={this._addMedicalExpertFee}
                            _updateMedicalExpertFees={this._updateMedicalExpertFees}
                            _handleChangeOpponent={this._handleChangeOpponent}
                            _handleTextInputChange={this._handleTextInputChange }
                            _handleSelectInputChange={this._handleSelectInputChange }
                            _handleDateInputChange={this._handleDateInputChange }
                            onDrop={this.onDrop}
                            checkIfQuestionIsEditable={this.props.checkIfQuestionIsEditable}
                            attachments={this.state.attachments}
                            workSourceOptions={this.props.workSourceOptions}
                            questions={this.props.Store.questions}
                            openDeleteAnswerModal={this.props.openDeleteAnswerModal}
                            opponentQuestions={this.props.opponentQuestions}
                            isApplicationTab={false}
                        />
                    </div>
                    {this.state.triggeredQuestion && this.state.triggeredQuestion.map(conditionalQuestion => {
                        //Check for which question have triggered the conditional question (if triggered)
                        var triggerQuestionsGroupIds =  checkWhichQuestionTriggeredConditional(this.state.formData,this.props.Store.questions,conditionalQuestion);
                        var istriggered = triggerQuestionsGroupIds.some(c => c == this.state.question.groupId );
                        return (
                            this._getChildQuestionsIds(this.state.question).includes(conditionalQuestion.id) &&
                            istriggered 
                            ?
                                <div key={conditionalQuestion.id}>
                                    <AnsweredQuestion
                                        multipleFilesAllowed={true}
                                        application={this.props.Store.selectedApplication}
                                        formData={this.state.formData}
                                        opponent={this.state.opponent}
                                        question={conditionalQuestion}
                                        questionAnswer={this.state.question.isStandard
                                            ? this.state.questionAnswer
                                            : this.state.formData[conditionalQuestion.id]
                                        }
                                        medicalExpertFees={this.state.medicalExpertFees}
                                        breachCausationCp={this.state.breachCausationCp}
                                        _removeMedicalExpertFee={this._removeMedicalExpertFee}
                                        _addMedicalExpertFee={this._addMedicalExpertFee}
                                        _updateMedicalExpertFees={this._updateMedicalExpertFees}
                                        _handleChangeOpponent={this._handleChangeOpponent}
                                        _handleTextInputChange={this._handleTextInputChange }
                                        _handleSelectInputChange={this._handleSelectInputChange }
                                        _handleDateInputChange={this._handleDateInputChange }
                                        onDrop={this.onDrop}
                                        checkIfQuestionIsEditable={this.props.checkIfQuestionIsEditable}
                                        attachments={this.state.attachments}
                                        questions={this.props.Store.questions}
                                        openDeleteAnswerModal={this.props.openDeleteAnswerModal}
                                        workSourceOptions={this.props.workSourceOptions}
                                        opponentQuestions={this.props.opponentQuestions}
                                        isApplicationTab={false}
                                    />
                                </div>
                            :
                                null
                        )
                    })}
                    <div className={'form-group'}>
                        <div className='col-sm-3'></div>
                        <div className={'col-sm-6'}>
                            <div className={'btn-wrapper-forForms'}>
                                <Button
                                    label={btnLabel}
                                    variant={PRIMARY}
                                    arrowDirection={RIGHT}
                                    type={SUBMIT}
                                    disabled={
                                        this.props.Store.updatingQuestionAnswer
                                        || this.props.Store.updatingApplicationAfterUpdatingApplicationAnswer
                                    }
                                    buttonTestId={'policy-application-SaveButtonModal'}
                                />
                            </div>
                            <div className={'btn-wrapper-forForms'}>
                                <Button
                                    label={CONTENT_STRINGS.CANCEL}
                                    variant={QUATERNARY}
                                    arrowDirection={RIGHT}
                                    onClick={this.props.closeEditQuestionAnswerModal}
                                    buttonTestId={'policy-application-CancelButtonModal'}
                                />
                            </div>
                            {this.props.Store.updatingQuestionAnswer || this.props.Store.updatingApplicationAfterUpdatingApplicationAnswer
                                ? 
                                    <div className={'btn-wrapper-forForms'}>
                                        <Loader variant={DOTS} dotSize={MEDIUM}/>
                                    </div>
                                :
                                    null
                            }
                        </div>
                    </div>
                    {this.state.errorMessage 
                        ?
                            <Alert 
                                variant={ERROR}
                                label={this.state.errorMessage}
                            />
                        : 
                            null
                    }
                    {this.props.Store.updatingQuestionAnswerFail
                        ?
                            <Alert
                                variant={ERROR}
                                label={this.props.Store.updatingQuestionAnswerFail}
                            />
                        : 
                            null
                    }
                    {this.state.attachments.length > 0 
                        ?
                            <div className={"form-group"}>
                                    <div className='col-sm-3'></div>
                                    <div className={'col-sm-6'}>
                                    <AttachmentsList
                                        attachments={this.state.attachments || []}
                                        onAttachmentRemove={this.removeAttachment}
                                    />
                                </div>
                            </div>
                        :
                            null
                    }
                </form>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        userRoles: state.user.loggedInUser.roles
    }
};

const mapDispatchToProps = (dispatch) => {
  return {
      updateFormQuestionAnswerAfterSubmit: (payload) => {
          dispatch(updateFormQuestionAnswerAfterSubmit(payload))
      }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FormQuestionAnswerEditForm);